import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { ConverterExchangeProtocolEnum } from '@zaoblako/shared/modules/pacs/enums/converter-exchange-protocol.enum';
import { ConverterExchangeProtocolEnumI18n } from '@zaoblako/shared/modules/pacs/i18n/converter-exchange-protocol-enum.i18n';

@Pipe({
  name: 'converterExchangeProtocolName',
  standalone: true
})
export class ConverterExchangeProtocolNamePipe implements PipeTransform {
  public transform(protocol: ConverterExchangeProtocolEnum): string {
    return ConverterExchangeProtocolEnumI18n[I18nLocalesEnum.RU_RU][protocol] || '';
  }
}
